<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form>
                <router-link
                  class="btn btn-outline-info"
                  :to="{ name: 'inventario-conteo' }"
                >
                  <i class="fa fa-arrow-left"></i>
                  Listado de Conteos
                </router-link>
                <h5 class="form-header">
                  Conteo de Inventario #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': !current.fecha_finalizacion,
                      'badge-warning': current.fecha_finalizacion,
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="!current.fecha_finalizacion">En Proceso</span>
                    <span v-if="current.fecha_finalizacion">Finalizado</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <!-- <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button> -->
                      &nbsp;

                      <div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            type="button"
                            class="dropdown-item"
                            @click="finalizarConteo()"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Finalizar Conteo
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <div class="row col-12">
                  <div class="col-sm-6 col-md-6">
                    <TiendaSelectComponent
                      :disabled="true"
                      :current="current"
                    />
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <UsuariosSelectComponent
                        :disabled="current.estado != 'A'"
                        :current="current"
                      />
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.fecha,
                        }"
                        >Fecha Creación</label
                      >
                      <input
                        v-model="current.fecha_creacion"
                        class="form-control"
                        placeholder="Fecha"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger': current.errors && current.errors.fecha,
                        }"
                        >Fecha Finalizado</label
                      >
                      <input
                        v-model="current.fecha_finalizacion"
                        class="form-control"
                        placeholder="Fecha Conteo"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  @click="showModalAddDetail()"
                  class="btn btn-success btn-md btn-block"
                  :disabled="current.fecha_finalizacion"
                >
                  Contar Producto
                </button>
                <br />
                <ConteoInventarioDetalleTableComponent
                  @refresh="refreshCurrent()"
                  :dataTabla="current"
                />
                <div class="form-buttons-w"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalDetalle"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Conteo de Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.sku }}
                </h6>
                <h6 class="font-weight-bold text-success">
                  {{ producto.producto_obj.nombre }}
                </h6>
              </div>
              <div class="col-sm-12">
                <label>Producto Barra</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="currentDetalle.barra_producto"
                  v-on:keyup.enter="setSelected()"
                />
                <br />
                <button
                  class="btn btn-md btn-success btn-block"
                  @click="setSelected()"
                >
                  Aceptar
                </button>
              </div>
              <div class="col-sm-12 mb-1">
                Lotes:
                <select
                  v-model="currentDetalle.producto_lote"
                  v-if="
                    currentDetalle.productolote_set != null &&
                    currentDetalle.productolote_set.length > 0
                  "
                  class="form-control"
                >
                  <option
                    v-for="detalle in currentDetalle.productolote_set"
                    :value="detalle.id"
                    v-bind:key="detalle.id"
                  >
                    Lote: {{ detalle.codigo_lote }} || Vence:
                    {{ detalle.fecha_vence }}
                  </option>
                </select>
              </div>
              <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                Bodega:
                <select
                  v-model="busqueda_posicion.bodega_id"
                  class="form-control"
                  @change="changeBodega"
                  autofocus="autofocus"
                >
                  <option
                    v-for="detalle in bodegas"
                    :value="detalle.id"
                    v-bind:key="detalle.bodega"
                  >
                    {{ detalle.bodega }} - {{ detalle.descripcion }}
                  </option>
                </select>
              </div>
              <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                Seccion:
                <select
                  v-model="busqueda_posicion.seccion_id"
                  class="form-control"
                  @change="changeSeccion"
                  autofocus="autofocus"
                >
                  <option
                    v-for="detalle in secciones"
                    :value="detalle.id"
                    v-bind:key="detalle.seccion"
                  >
                    {{ detalle.seccion }} - {{ detalle.descripcion }}
                  </option>
                </select>
              </div>
              <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                Rack:
                <select
                  v-model="busqueda_posicion.rack_id"
                  class="form-control"
                  @change="changeRack"
                  autofocus="autofocus"
                >
                  <option
                    v-for="detalle in racks"
                    :value="detalle.id"
                    v-bind:key="detalle.rack"
                  >
                    {{ detalle.rack }} - {{ detalle.descripcion }}
                  </option>
                </select>
              </div>
              <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                Nivel:
                <select
                  v-model="busqueda_posicion.nivel_id"
                  class="form-control"
                  @change="changeNivel"
                >
                  <option
                    v-for="detalle in niveles"
                    :value="detalle.id"
                    v-bind:key="detalle.nivel"
                  >
                    {{ detalle.nivel }} - {{ detalle.descripcion }}
                  </option>
                </select>
              </div>

              <div v-if="currentDetalle.posicion" class="col-sm-6 mb-1">
                Posicion:
                <select v-model="currentDetalle.posicion" class="form-control">
                  <option
                    v-for="detalle in posiciones"
                    :value="detalle.posicion_id"
                    v-bind:key="detalle.id"
                  >
                    {{ detalle.codigo_barra }}
                  </option>
                </select>
                <small
                  v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                  class="form-text text-danger"
                  >{{ currentDetalle.errors.posicion }}</small
                >
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors &&
                        currentDetalle.errors.cantidad0,
                    }"
                    >Cantidad en Unidades</label
                  >
                  <input
                    v-model="currentDetalle.cantidad"
                    class="form-control"
                    placeholder="Cantidad"
                    type="text"
                    style="text-align: center; font-size: 200%"
                    v-bind:class="{
                      'is-invalid':
                        currentDetalle.errors && currentDetalle.errors.cantidad,
                    }"
                    v-on:keyup.enter="agregaDetalle"
                  />
                  <small
                    v-if="
                      currentDetalle.errors && currentDetalle.errors.cantidad
                    "
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.cantidad }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="agregaDetalle"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PosicionesService from "@/services/inventario/PosicionesService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import ConteoInventarioDetalleTableComponent from "@/components/inventario/conteo_inventario/ConteoInventarioDetalleTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    UsuariosSelectComponent,
    ConteoInventarioDetalleTableComponent,
    ProductoSelectComponent,
  },
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "",
        estado: "A",
        errors: [],
      },

      productos: [],
      posiciones: [],
      options: [],
      producto_lote: [],
      producto: {
        producto_obj: "",
      },
      bodegas: [],
      secciones: [],
      racks: [],
      niveles: [],

      busqueda_posicion: {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      },
      currentDetalle: {
        cantidad: 0,
        posicion: "",
        producto: "",
        codigo_lote: 0,
        productolote_set: [],
        errors: [],
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },
    refreshCurrent() {
      let self = this;
      DynamicService.getById(
        "inv",
        "conteo-inventario",
        this.$route.params.id
      ).then((response) => {
        self.current = response.data;
        self.current.fecha_creacion = moment(
          self.current.fecha_creacion
        ).format("DD/MM/YYYY HH:mm:ss A");
        if (self.current.fecha_finalizacion) {
          self.current.fecha_finalizacion = moment(
            self.current.fecha_finalizacion
          ).format("DD/MM/YYYY HH:mm:ss A");
        }
      });
    },
    showModalAddDetail() {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
      PosicionesService.fetch({
        page: 1,
        tienda: self.current.tienda,
        activo: true,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalDetalle").modal();
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      DynamicService.postAction(
        "inv",
        "conteo-inventario",
        self.current.id,
        "contar",
        det
      )
        .then((response) => {
          Notifications.alert.success(
            "Conteo de producto",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          console.log(error.response.data);
          self.currentDetalle.errors = error.response.data;
        });
    },
    finalizarConteo() {
      let self = this;
      Notifications.alert.confirm(
        "Conteo de Inventario",
        "Desea Finalizar la transacción?",
        "Si Finalizar",
        function () {
          DynamicService.postAction(
            "inv",
            "conteo-inventario",
            self.current.id,
            "finalizar"
          )
            .then((response) => {
              Notifications.alert.success(
                "Conteo de Inventario",
                "Se ha Finalizado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Finalizar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    refreshDetalleDefault() {
      let self = this;
      (self.busqueda_posicion = {
        bodega_id: null,
        seccion_id: null,
        rack_id: null,
        posicion_id: null,
      }),
        (self.currentDetalle = {
          barra_producto: "",
          cantidad: 0,
          producto_lote: "",
          posicion: "",
          errors: [],
        });
      self.producto.producto_obj.sku = "";
      self.producto.producto_obj.nombre = "";
    },
    refreshBodegas() {
      let self = this;
      DynamicService.fetch("cat", "tienda-bodega", {
        tienda: self.current.tienda,
        quitar_paginacion: true,
      }).then((res) => {
        self.bodegas = res.data;
        if (self.busqueda_posicion.bodega_id == null) {
          self.busqueda_posicion.bodega_id = self.bodegas[0].id;
          this.refreshSecciones();
        }
      });
    },
    changeBodega() {
      this.refreshSecciones();
    },
    changeSeccion() {
      this.refreshRacks();
    },
    changeRack() {
      this.refreshNiveles();
    },
    changeNivel() {
      this.refreshPosiciones();
    },
    refreshSecciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-seccion", {
        tienda: self.current.tienda,
        bodega: self.busqueda_posicion.bodega_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.secciones = res.data;
        if (self.busqueda_posicion.seccion_id == null) {
          self.busqueda_posicion.seccion_id = self.secciones[0].id;
          this.refreshRacks();
        }
      });
    },
    refreshPosiciones() {
      let self = this;
      let params = {
        page: 1,
        tienda: self.current.tienda,
        quitar_paginacion: true,
      };
      if (self.busqueda_posicion.bodega_id) {
        params.bodega_id = self.busqueda_posicion.bodega_id;
      }
      if (self.busqueda_posicion.seccion_id) {
        params.seccion_id = self.busqueda_posicion.seccion_id;
      }
      if (self.busqueda_posicion.rack_id) {
        params.rack_id = self.busqueda_posicion.rack_id;
      }
      if (self.busqueda_posicion.nivel_id) {
        params.nivel_id = self.busqueda_posicion.nivel_id;
      }
      PosicionesService.fetch(params).then((res) => {
        self.posiciones = res.data;
        if (self.busqueda_posicion.posicion_id == null) {
          self.currentDetalle.posicion = self.posiciones[0].id;
        }
      });
    },
    refreshRacks() {
      let self = this;
      DynamicService.fetch("cat", "tienda-rack", {
        tienda: self.current.tienda,
        seccion: self.busqueda_posicion.seccion_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.racks = res.data;
        if (self.busqueda_posicion.rack_id == null) {
          self.busqueda_posicion.rack_id = self.racks[0].id;
          this.refreshNiveles();
        }
      });
    },
    refreshNiveles() {
      let self = this;
      DynamicService.fetch("cat", "tienda-nivel", {
        tienda: self.current.tienda,
        rack: self.busqueda_posicion.rack_id,
        quitar_paginacion: true,
      }).then((res) => {
        self.niveles = res.data;
        if (self.busqueda_posicion.nivel_id == null) {
          self.busqueda_posicion.nivel_id = self.niveles[0].id;
          this.refreshPosiciones();
        }
      });
    },
    setSelected(value) {
      DynamicService.fetch("cat", "producto-barra", {
        barra: this.currentDetalle.barra_producto,
      }).then((response) => {
        this.producto = response.data.results[0];
        if (!this.producto) {
          Notifications.alert.error(
            "Buscar Producto",
            "Ningun Producto Encontrado"
          );
        }
        ProductosService.getById(this.producto.producto_obj.sku).then((res) => {
          this.currentDetalle.productolote_set = res.data.productolote_set;
          this.currentDetalle.producto_lote = res.data.productolote_set[0].id;
        });
      });
      this.refreshBodegas();
    },
  },
};
</script>
